import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {Scope} from "../../store/state/order.state";
import {ScopesFetchService} from "./scopes-fetch.service";

@Injectable()
export class ScopesResolver implements Resolve<Observable<{ [accBody: string] : Scope[] }>> {

	constructor(private fetchService: ScopesFetchService) {
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<{ [accBody: string] : Scope[] }> {
		return this.fetchService.fetchScopes();
	}
}
